import React from "react";
import { StepCounter } from "./kit/StepCounter";

/**
 * #1122 (D250) — the log flow's "Step N of 3", always in the page body at every
 * width, as the kit's `StepCounter variant="eyebrow"`. The top bar carries no
 * caption (the labelled Account control leaves it no room).
 */
export default function LogStepEyebrow({ step, total, "data-testid": testId = "log-step-eyebrow" }) {
  return (
    <div style={{ padding: "12px 20px 0" }} data-testid={testId}>
      <StepCounter step={step} total={total} variant="eyebrow" />
    </div>
  );
}
